import { enableProdMode, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';

import { environment } from './environments/environment';

import { registerLocaleData, CommonModule } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { LoaderService } from './app/services/loader.service';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { tokenInterceptor } from './app/helpers/token.interceptor';
import { errorInterceptor } from './app/helpers/error.interceptor';
import { loaderInterceptor } from './app/services/loader-interceptor.service';
import { BASE_PATH } from 'src/app/core/clientV2';
import { HIGHCHARTS_MODULES } from 'angular-highcharts';
import * as more from 'highcharts/highcharts-more.src';
import * as exporting from 'highcharts/modules/exporting.src';
import { MAT_RIPPLE_GLOBAL_OPTIONS, RippleGlobalOptions } from '@angular/material/core';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { SessionModule } from './app/sessions/session/session.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app/app-routing.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { AgGridModule } from 'ag-grid-angular';
import { AllCommunityModule, ClientSideRowModelModule, ModuleRegistry, ValidationModule } from 'ag-grid-community';
import { AppComponent } from './app/app.component';

registerLocaleData(localeIt);
ModuleRegistry.registerModules([
    AllCommunityModule,
    ClientSideRowModelModule,
    ...(!environment.production ? [ValidationModule] : [])
]);

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),importProvidersFrom(BrowserModule, SessionModule, FormsModule, AppRoutingModule, ReactiveFormsModule, ToastrModule.forRoot(),
        CommonModule, AgGridModule),
        LoaderService,
        { provide: LOCALE_ID, useValue: 'it-IT' },
        { provide: BASE_PATH, useValue: environment.apiUrl },
        { provide: HIGHCHARTS_MODULES, useFactory: () => [more, exporting] },
        { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: { disabled: true } as RippleGlobalOptions },
        provideHttpClient(withInterceptors([tokenInterceptor, errorInterceptor, loaderInterceptor])),
        provideAnimations()
    ]
})
  .catch(err => console.error(err));
